import { Link } from "react-router-dom";
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faBars, faXmark } from "@fortawesome/free-solid-svg-icons";
import { motion, AnimatePresence } from "framer-motion";
import constants from "../constants/constants";
import { useUserParams } from "../hooks/useUserParams";


export default function MobileHeader() {
  const [open, setOpen] = useState(false);
  const [activeMenu, setActiveMenu] = useState(null);
  const { getCurrentLogo } = useUserParams();

  const toggleMenu = (slug) => {
    setActiveMenu((prev) => (prev === slug ? null : slug));
  };

  const itemVariants = {
    closed: {
      opacity: 0,
      x: 30,
    },
    open: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.35,
      },
    },
  };

  return (

    <header
      className="fixed top-5 left-0 right-0 z-[100] px-5 lg:px-8"
    >
      <nav
        className="flex h-20 items-center justify-between rounded-3xl bg-harbour-navy px-5 shadow-xl border border-white"
      >
        {/* Logo */}
        <Link to="/">
          <img
            src={getCurrentLogo()}
            className="h-8"
            alt="Logo"
          />
        </Link>

        {/* Menu Button */}
        <button
          onClick={() => setOpen(!open)}
          className="flex h-12 w-12 items-center justify-center rounded-full bg-harbour-navy text-white"
        >
          <FontAwesomeIcon
            icon={open ? faXmark : faBars}
            className="fa-xl"
          />
        </button>
      </nav>

      {/* Mobile Menu */}
      <AnimatePresence>
        {
          open &&
          <>
            {/* Backdrop */}
            <motion.div
              initial={{
                opacity: 0
              }}
              animate={{
                opacity: 0.7
              }}
              exit={{
                opacity: 0
              }}
              transition={{
                duration: 0.3
              }}
              onClick={() => setOpen(false)}
              className="fixed inset-0 bg-black z-[-1]"
            />

            <motion.div
              initial={{
                opacity: 0,
                y: -20
              }}

              animate={{
                opacity: 1,
                y: 0
              }}

              exit={{
                opacity: 0,
                y: -20
              }}

              className="mt-3 rounded-3xl bg-white p-6 shadow-2xl">
              <div className="flex flex-col gap-5">
                {
                  constants.NAVIGATION.map((item) => {
                    if (!item.children) {
                      return (
                        <Link
                          key={item.title}
                          to={item.to}
                          onClick={() => setOpen(false)}
                          className="uppercase tracking-[0.2em] text-sm text-harbour-navy"
                        >
                          {item.title}
                        </Link>
                      )
                    }

                    return (
                      <motion.div
                        key={item.title}
                        variants={itemVariants}

                      >
                        {/* Parent Menu */}
                        <button
                          onClick={() => toggleMenu(item.slug)}
                          className="uppercase tracking-[0.2em] text-sm text-harbour-navy"
                        >
                          <span>{item.title}</span>

                          <FontAwesomeIcon
                            icon={faAngleDown}
                            className={`ml-3 duration-300 ${activeMenu === item.slug ? "rotate-180" : ""
                              }`}
                          />
                        </button>

                        {/* Submenus */}
                        <AnimatePresence>
                          {activeMenu === item.slug && (
                            <motion.div
                              initial={{ height: 0, opacity: 0 }}
                              animate={{ height: "auto", opacity: 1 }}
                              exit={{ height: 0, opacity: 0 }}
                              transition={{ duration: 0.3 }}
                              className="overflow-hidden"
                            >
                              {item.children.map((child) => (
                                <Link
                                  key={child.to}
                                  to={child.to}
                                  onClick={() => setOpen(false)}
                                  className="block py-3 pl-6 uppercase tracking-[0.2em] text-sm text-harbour-navy"
                                >
                                  {child.title}
                                </Link>
                              ))}
                            </motion.div>
                          )
                          }
                        </AnimatePresence>
                      </motion.div>
                    );
                  })
                }
                <Link
                  to={'/contact'}
                  onClick={() => setOpen(false)}
                  className="uppercase tracking-[0.2em] text-sm text-harbour-navy"
                >
                  Contact
                </Link>
              </div>
            </motion.div>
          </>
        }
      </AnimatePresence >
    </header >
  );
}
